import { useState, useEffect } from 'react';
import Swal from 'sweetalert2';

const Contactemail = () => {
  const [result, setResult] = useState('');

  const onSubmit = async (event) => {
    event.preventDefault();
    setResult("Sending....");
    const formData = new FormData(event.target);

    formData.append("access_key", "f18a07ae-00ae-49c8-b9df-0a8ed2b9ceec");

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData
    });

    const data = await response.json();

    if (data.success) {
      setResult("Form Submitted Successfully");
      event.target.reset();

      // Display SweetAlert2 popup for successful submission
      Swal.fire({
        icon: 'success',
        title: 'Message Sent!',
        text: 'Your message has been sent successfully.',
        confirmButtonText: 'OK'
      });
    } else {
      console.log("Error", data);
      setResult(data.message);
      
      // Optional: Display an error alert
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: 'Something went wrong!',
        confirmButtonText: 'Try Again'
      });
    }
  };


  //const handleMouseMove = (event) => {
    //const contactElement = document.querySelector('.Contactemail');
    //const x = (event.clientX / window.innerWidth) * 100;
    //const y = (event.clientY / window.innerHeight) * 100;
    
    // Move the background based on cursor position
    //contactElement.style.backgroundPosition = `${x}% ${y}%`;
  //};

  //useEffect(() => {
    // Attach the mousemove event to the document
    //document.addEventListener('mousemove', handleMouseMove);

    // Cleanup the event listener on component unmount
    //return () => {
      //document.removeEventListener('mousemove', handleMouseMove);
    //};
  //}, []);

  return (
    <section className='Contactemail'>
      <form onSubmit={onSubmit}>
        <h2>Contact Form</h2>
        <div className="input-box">
          <label> Full Name</label>
          <input type='text' className='field' placeholder='Enter your name' name = 'name' required />
        </div>
        <div className="input-box">
          <label> Email Address</label>
          <input type='email' className='field' placeholder='Enter your email' name = 'email' required />
        </div>
        <div className="input-box">
          <label> Your Message</label>
          <textarea name='message' className='field mess' placeholder='Enter your message' required ></textarea>
        </div>
        <button type='submit'>Send Message</button>
                </form>
    </section>
  )
}

export default Contactemail;